module.exports = "<router-outlet></router-outlet>\r\n<ngx-loading-bar color=\"#3A58C5\" [includeSpinner]=\"false\"></ngx-loading-bar>\r\n"